"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ConsoleLogger {
    debug(data, msg) {
        console.log(data || msg, data && msg);
    }
    info(data, msg) {
        console.log(data || msg, data && msg);
    }
    warn(data, msg) {
        console.error(data || msg, data && msg);
    }
    error(data, msg) {
        console.error(data || msg, data && msg);
    }
    fatal(data, msg) {
        console.error(data || msg, data && msg);
    }
}
exports.ConsoleLogger = ConsoleLogger;
